import { render, staticRenderFns } from "./employee-insurance-item.vue?vue&type=template&id=13171846"
import script from "./employee-insurance-item.vue?vue&type=script&lang=js"
export * from "./employee-insurance-item.vue?vue&type=script&lang=js"
import style0 from "./employee-insurance-item.vue?vue&type=style&index=0&id=13171846&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports